import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVert from "@mui/icons-material/MoreVert";
import { useState } from "react";

export type RowMenuItem = {
    label: string;
    danger?: boolean;
    disabled?: boolean;
    onClick: () => void;
};

// RowMenu holds a list row's actions behind one button, for a phone that hasn't the
// width to show them all
export function RowMenu(props: { items: RowMenuItem[] }) {
    const [anchor, setAnchor] = useState<HTMLElement | null>(null);

    if (props.items.length === 0) return null;

    return (
        <>
            <IconButton edge="end" aria-label="Actions" onClick={e => setAnchor(e.currentTarget)}>
                <MoreVert />
            </IconButton>
            <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)}>
                {props.items.map(item => (
                    <MenuItem key={item.label} disabled={item.disabled}
                              sx={item.danger ? { color: "error.main" } : undefined}
                              onClick={() => {
                                  setAnchor(null);
                                  item.onClick();
                              }}>
                        {item.label}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}
